<div class="loader-wrapper" *ngIf="loading">
  <div class="loader">
    <mat-spinner></mat-spinner>
  </div>
</div>
<div class="product-list account-tab-page order-detail">
  <div class="container">
    <div class="row" *ngIf="orderDetail">
      <div class="col-md-12">
        <div class="tabbable tabs-left">
          <div class="col-md-12">
            <div class="tab-content">
              <div class="tab-pane active" id="your_orders">
                <div class="tab_body">
                  <div class="your-order" id="track-order2">
                    <div class="track-order">
                      <div class="icon">
                        <img src="/assets/images/thankyou-icon.png" aria-hidden="true" />
                      </div>
                      <div class="header-title">
                        <h2>{{ 'Thank you for your Purchase' }}!</h2>
                        <h3>{{ 'Order' | translate }} #{{ orderDetail.order_id }}</h3>
                        <p>
                          {{ 'You placed this order on' | translate }}
                          {{ orderDetail.orderDate | date: 'medium' }}
                        </p>
                        <a href="https://bfxuryjlu8n.typeform.com/to/F3Zvl3gr" target="_blank">
                          <button class="btn btn-primary thank-you">How did you discover us?</button>
                        </a>
                        <h4>{{ 'Your order summary' | translate }}</h4>
                      </div>
                      <div class="order-summary-bottom">
                        <table
                          *ngFor="let order of orderItems.orders.order_item"
                          class="order-summary-details desktopproductdetails"
                        >
                          <app-order-success-detail
                            class="app-order-detail"
                            [orderItem]="order"
                            [country_data]="orderItems.country_data"
                            [orderDetail]="orderItems.data"
                          ></app-order-success-detail>
                        </table>
                        <table
                          *ngFor="let order of orderItems.orders.order_item"
                          class="order-summary-details mobileproductdetails"
                        >
                          <app-order-success-detail-mobile
                            class="app-order-detail"
                            [orderItem]="order"
                            [country_data]="orderItems.country_data"
                            [orderDetail]="orderItems.data"
                          ></app-order-success-detail-mobile>
                        </table>
                        <table [ngStyle]="{ width: '100%' }" class="order-summary-details">
                          <tr class="orderbottom">
                            <td colspan="3" valign="center">
                              <div class="product-detail">
                                <p class="sub-total-section">
                                  <span class="summary-label">{{ 'Subtotal' | translate }}:</span>
                                  <span class="total-price">
                                    {{ itemTotalFinal | currencyCode: orderDetail.currencycode }}
                                  </span>
                                </p>
                                <p *ngIf="itemDiscountFinal != 0">
                                  <span class="summary-label">{{ 'Discount' | translate }}:</span>
                                  <span class="total-price">
                                    -{{ itemDiscountFinal | currencyCode: orderDetail.currencycode }}
                                  </span>
                                </p>
                                <div
                                  class="shipping-charges-section"
                                  *ngIf="itemShippingFinal || orderDetail.totalAuthFee"
                                >
                                  <p *ngIf="itemShippingFinal">
                                    <span class="summary-label">{{ 'Shipping Fees' | translate }}:</span>
                                    <span class="total-price">
                                      {{ itemShippingFinal | currencyCode: orderDetail.currencycode }}
                                    </span>
                                  </p>
                                  <p *ngIf="orderDetail.totalAuthFee && orderDetail.totalAuthFee > 0">
                                    <span class="summary-label">{{ 'Authentication Fees' | translate }}:</span>
                                    <span class="total-price">
                                      {{ orderDetail.totalAuthFee | currencyCode: orderDetail.currencycode }}
                                    </span>
                                  </p>
                                </div>

                                <p>
                                  <span class="summary-label bold-font-content">
                                    {{ 'Total (incl. tax)' | translate }}:
                                  </span>
                                  <span class="total-price bold-font-content">
                                    {{ itemTaxTotalFinal | currencyCode: orderDetail.currencycode }}
                                  </span>
                                </p>
                              </div>
                            </td>
                          </tr>
                        </table>
                        <div class="address-summary-section">
                          <div class="address-summary-col">
                            <div class="ordersummary">
                              <h3>{{ 'Order Summary' | translate }}</h3>
                              <p>{{ 'Order' | translate }}: #{{ orderDetail.order_id }}</p>
                              <p>
                                {{ 'Order Date' | translate }}:
                                {{ orderDetail.orderDate | date: 'medium' }}
                              </p>
                              <p>
                                {{ 'Order Total' | translate }}:
                                {{ orderDetail.total_paid_amount | currency: orderDetail.currencycode }}
                              </p>
                            </div>
                          </div>
                          <div class="address-summary-col">
                            <div class="shippingaddress">
                              <h3>{{ 'Shipping Address' | translate }}</h3>
                              <p>
                                <span>{{ orderDetail.name }}</span>
                                <span>
                                  {{ orderDetail.phone_code ? '+' + orderDetail.phone_code : '' }}
                                  {{ orderDetail.mobile_no }}
                                </span>
                                <span>
                                  {{ orderDetail.company }} {{ orderDetail.address_1 }}
                                  {{ orderDetail.address_2 }}
                                </span>
                                <span>{{ orderDetail.city }} {{ orderDetail.pin_code }}</span>
                                <span>{{ orderDetail.country_name }}</span>
                              </p>
                            </div>
                          </div>
                          <div class="address-summary-col">
                            <div class="billingaddress">
                              <h3>{{ 'Billing address' | translate }}</h3>
                              <p>
                                <span>{{ orderDetail.billing_name }}</span>
                                <span *ngIf="orderDetail.billing_mobile_no != ''">
                                  {{ orderDetail.billing_phone_code ? '+' + orderDetail.billing_phone_code : '' }}
                                  {{ orderDetail.billing_mobile_no }}
                                </span>
                                <span *ngIf="orderDetail.billing_mobile_no == ''">
                                  {{ orderDetail.phone_code ? '+' + orderDetail.phone_code : '' }}
                                  {{ orderDetail.mobile_no }}
                                </span>
                                <span>
                                  {{ orderDetail.billing_company }}
                                  {{ orderDetail.billing_address_1 }}
                                  {{ orderDetail.billing_address_2 }}
                                </span>
                                <span>
                                  {{ orderDetail.billing_city }}
                                  {{ orderDetail.billing_pin_code }}
                                </span>
                                <span>{{ orderDetail.billing_country_name }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="order-review-des-section">
                        <h4>NEXT STEPS</h4>
                        <p>
                          1. Your item will now be sent by the seller to our Copenhagen office for Quality Control
                          (unless you’ve bought a TVB item which has already undergone Quality Control or you’ve bought
                          an item using direct shipping).
                        </p>
                        <p>
                          2. Our brand experts will conduct a thorough Quality Control (unless you’ve opted for direct
                          shipping). 3. You item will be sent to you.
                        </p>
                        <hr />
                        <h4>DELIVERY</h4>
                        <p>
                          If you’ve chosen Direct shipping, the item will be sent directly to your chosen address
                          without undergoing Quality Control at the TVB office.
                        </p>
                        <p>
                          With Authenticated shipping you can expect a delivery time of 5-7 business days for items
                          already at the TVB office, 6-21 business days for items from both professional and private
                          sellers.
                        </p>
                        <p>
                          To make sure the delivery time’s as fast as possible, we’ll ask the seller to ship your item
                          as soon as possible.
                        </p>
                        <hr />
                        <h4>POSTAGE AND PACKAGING</h4>
                        <p>Delivery by DHL or GLS.</p>
                      </div>

                      <div class="bottomtext">
                        <p>{{ 'orderconfirm1' | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-order-confirmation">
      <div class="row">
        <div class="col-md-6 col-sm-6 col-xs-6">
          <div class="footerleft">
            <h3>{{ 'How to Reach Us' | translate }}</h3>
            <p>
              <i class="fa fa-phone" aria-hidden="true"></i>
              +45 78 71 87 70
            </p>
            <p>
              <a href="mailto:contact@thevintagebar.com">
                <i class="fa fa-envelope-o" aria-hidden="true"></i>
                contact@thevintagebar.com
              </a>
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-6">
          <div class="footerleft">
            <h3>{{ 'Learn about Our' | translate }}</h3>
            <p>{{ 'Return Policy' | translate }}</p>
            <p>
              <a routerLink="/{{ 'returns' | translate }}" class="read-more">
                {{ 'Read more' | translate }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="awinMerchantId">
  <img
    src="https://www.awin1.com/sread.img?tt=ns&tv=2&merchant={{ awinMerchantId }}&amount={{ orderItemTotal }}&cr={{
      orderItems.data.currencycode
    }}&ref={{ orderItems.data.order_id }}&parts=default:{{ orderItemTotal }}&vc={{ coupon }}&ch=aw&testmode={{
      awinFlag
    }}"
    border="0"
    width="0"
    height="0"
  />
</ng-container>
